import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, Grid, Container } from "@mui/material";
import { styles } from "../../components/formStyles";
import CustomButton from "../../constant/commonButton";
import "../../../style/style.css";
import ReusableFormFields from "../../constant/reusableFormFields";
import { useNavigate } from "react-router-dom";
import { wholesalerViewRequest } from "../../../redux/wholesaler/WholesalerAction";

const inputFields = [
  {
    name: "first_name",
    label: "First Name",
    rules: { required: "Name is required" },
    readOnly: true,
  },
  {
    name: "last_name",
    label: "Last Name",
    rules: { required: "Name is required" },
    readOnly: true,
  },
  {
    name: "address",
    label: "Address",
    rules: { required: "Address is required" },
    readOnly: true,
  },
  {
    name: "email",
    label: "Email Address",
    rules: {
      required: "Email is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid email format",
      },
    },
    readOnly: true,
  },
  {
    name: "contact",
    label: "Phone No",
    rules: {
      required: "Phone No is required",
      pattern: {
        value: /^\d{8,}$/,
        message: "Invalid Phone Number",
      },
    },
    readOnly: true,
  },
  {
    name: "working_time",
    label: "Shop Open and Close time",
    rules: { required: "Shop Open and Close time is required" },
    readOnly: true,
  },
];

const ViewWholeSaler = () => {
  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const navigator = useNavigate();
  const wholesalerData = useSelector(
    (state) => state?.wholesaler?.viewWholesaler.data || {}
  );

  const wholesalerId = localStorage?.getItem("wholesalerId");

  useEffect(() => {
    if (wholesalerId) {
      dispatch(wholesalerViewRequest(wholesalerId));
    }
  }, [wholesalerId, dispatch]);

  useEffect(() => {
    if (wholesalerData) {
      setValue("first_name", wholesalerData?.first_name);
      setValue("last_name", wholesalerData?.last_name);
      setValue("address", wholesalerData?.address);
      setValue("email", wholesalerData?.email);
      setValue("contact", wholesalerData?.contact);
      setValue("working_time", wholesalerData?.working_time);
    }
  }, [wholesalerData, setValue]);

  return (
    <Container>
      <Grid container spacing={2} sx={{ marginLeft: "none" }}>
        <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
          <Box>
            <Typography
              variant="h5"
              gutterBottom
              sx={styles.title}
              className="headingTable"
            >
              <h1> Profile Overview </h1>
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={6} xl={5}></Grid>
        {/* Input Fields */}
        <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
          <ReusableFormFields
            inputFields={inputFields}
            control={control}
            errors={errors}
            register={register}
          />

          {/* Submit Button */}
          <Box sx={styles.submitGap}>
            <Grid item xs={3}>
              <CustomButton
                text="Edit"
                size="halfMedium"
                onClick={() =>
                  navigator(`/wholesaler/edit/profile/${wholesalerId}`)
                }
                buttonStyle="StyledButton"
              />
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ViewWholeSaler;
